import React from "react"
import { Stack } from "@mui/material";

function VOBRepWorklist(){
    return <React.Fragment>
        <Stack justifyContent='center' alignItems='center'>
            <iframe title="VOB Rep Worklist" width="1350" height="800" src="https://app.powerbi.com/reportEmbed?reportId=84841a85-2508-4f55-9cb2-bb4c8bcf1ee6&autoAuth=true&ctid=49423d5d-8d49-4128-b53d-59537808f6ac" allowFullScreen={true}></iframe>
        </Stack>
    </React.Fragment>
}

export{VOBRepWorklist}
